export { };
export const defaults = {
	app: {
		applicationId: 'damagedeclarationohc',
		pageEditorClass: 'is-page-editor',
		validatorRules: {
			rules: {
				BetroffenePerson: {
					required: true
				},
				SchadenTyp: {
					required: true
				},
				BetroffenePersonVorname: {
					required: true,
					minlength: 3,
					maxlength: 30,
					nonumber: true
				},
				BetroffenePersonNachname: {
					required: true,
					minlength: 3,
					maxlength: 30,
					nonumber: true
				},
				BetroffenePersonGemeldet: {
					required: true
				},
				KostenAngaben: {
					minlength: 3,
					maxlength: 1000
				},
				Datum: {
					requireddate: true,
					requireddatepast: true,
					requiredmindate: "01.01.1980"
				},
				SchadenLand: {
					required: true
				},
				Behandlung: {
					required: true
				},
				EigeneAngabenBeschreibung: {
					minlength: 3,
					maxlength: 1000
				},
				KostenbelegUpload: {
					allowedfiletype: true,
					maxfilesize: true,
					maxfilesizesummary: true,
					maxfilecount: true,
					onlySelectedFiles: true,
					emptyActiveCostType: true,
					customflagvalidation: true
				},
				Betrag: {
					requiredsum: true,
					pattern: "[0-9\\,]*$"
				},
				Upload: {
					allowedfiletype: true,
					maxfilesize: true,
					maxfilesizesummary: true,
					maxfilecount: true,
					onlySelectedFiles: true,
					customflagvalidation: true
				},
				UploadRequried: {
					requiredUploadedFile: true
				},
				Vorname: {
					required: true,
					inputcross: ['Nachname'],
					minlength: 2,
					maxlength: 30,
					pattern: "^[a-zA-ZüäöÜÄÖÜß\\-\\,\\.\\:\\;\\%\\&\\#\\d\\s]+$"
				},
				Nachname: {
					required: true,
					inputcross: ['Vorname'],
					minlength: 2,
					maxlength: 30,
					pattern: "^[a-zA-ZüäöÜÄÖÜß\\-\\,\\.\\:\\;\\#\\d\\s]+$"
				},
				Mitgliedsnummer: {
					maxlength: 9,
					number: true,
					required: true
				},
				StrasseHausnummer: {
					required: true,
					minlength: 2,
					maxlength: 30,
					streetandnumber: true,
					customflagvalidation: true
				},
				Postleitzahl: {
					required: true,
					inputcross: ['Ort'],
					minlength: 3,
					maxlength: 10,
					number: true,
					customflagvalidation: true
				},
				Ort: {
					required: true,
					inputcross: ['Postleitzahl'],
					minlength: 2,
					maxlength: 50,
					pattern: "^[a-zA-ZüäöÜÄÖÜß\\-\\.\\s]+$"
				},
				Email: {
					required: true,
					customflagvalidation: true,
					email: true
				},
				TelefonVorwahl: {
					phonecross: true,
					maxlength: 8,
					customflagvalidation: true,
					pattern: "^[0-9]*$"
				},
				TelefonNummer: {
					phonecross: true,
					maxlength: 20,
					customflagvalidation: true,
					pattern: "^[0-9]*$"
				},
				Kontoinhaber: {
					required: true,
					minlength: 3,
					maxlength: 50
				},
				Iban: {
					maxlength: 34,
					required: true,
					customflagvalidation: true
				},
				Bic: {
					required: true,
					minlength: 8,
					maxlength: 11,
					pattern: "^[a-zA-Z0-9]+$",
					customflagvalidation: true
				},
				WeitereVersicherungsgesellschaft: {
					required: true,
					minlength: 3,
					maxlength: 100
				},
				WeitereVersicherungsnummer: {
					minlength: 3,
					maxlength: 100
				},
				VersicherungReiseschtuz: {
					required: true
				},
				VersicherungReiseschutzKreditkartengesellschaft: {
					minlength: 3,
					maxlength: 100
				},
				VersicherungReiseschutzKreditkartennummer: {
					number: true,
					minlength: 13,
					maxlength: 16
				},
				VersicherungReiseschutzBankname: {
					minlength: 3,
					maxlength: 100
				},
				VersicherungUnfallschutz: {
					required: true
				},
				WeitereVersicherungsgesellschaftAnschrift: {
					required: true,
					minlength: 3,
					maxlength: 200
				},
				Datenschutz: {
					required: true
				},
				Obliegenheiten: {
					required: true
				},
				Datenspeicherung: {
					required: true
				},
				Geburtsdatum: {
					requireddate: true,
					customdob: true,
					customflagvalidation: true,
					requireddatepast: true
				}
			}
		},
		validationmessages: {
			client: {
				Geburtsdatum: {
					requireddate: "Bitte geben Sie ein gültiges Datum ein!",
					customdob: "Bitte geben Sie ein gültiges Datum ein!",
					customflagvalidation: "Bitte prüfen Sie Ihre Eingabe!",
					requireddatepast: "Geburtsdatum kann nicht in der Zukunft liegen!"
				},
				SchadenTyp: {
					required: "Sie haben kein Schadentyp eingegeben. Bitte korrigieren Sie ihre Eingabe!"
				},
				BetroffenePerson: {
					required: "Sie haben keine betroffene Person eingegeben. Bitte korrigieren Sie ihre Eingabe!"
				},
				BetroffenePersonVorname: {
					required: "Bitte machen Sie eine Eingabe!",
					minlength: "Bitte mindestens {0} Buchstaben",
					maxlength: "Bitte maximal {0} Buchstaben",
					nonumber: "Bitte prüfen Sie Ihre Eingabe!"
				},
				BetroffenePersonNachname: {
					required: "Bitte machen Sie eine Eingabe!",
					minlength: "Bitte mindestens {0} Buchstaben",
					maxlength: "Bitte maximal {0} Buchstaben",
					nonumber: "Bitte prüfen Sie Ihre Eingabe!"
				},
				BetroffenePersonGemeldet: {
					required: "Bitte machen Sie eine Eingabe!"
				},
				KostenAngaben: {
					minlength: "Bitte mindestens {0} Buchstaben",
					maxlength: "Bitte maximal {0} Buchstaben"
				},
				SchadenLand: {
					required: "Bitte machen Sie eine Eingabe!"
				},
				Datum: {
					requireddate: "Bitte geben Sie ein valides Datum ein.",
					requireddatepast: "Bitte geben Sie ein valides Datum ein.",
					requiredmindate: "Das Datum darf nicht zu weit in der Vergangenheit liegen."
				},
				Behandlung: {
					required: "Bitte machen Sie eine Eingabe!"
				},
				EigeneAngabenBeschreibung: {
					minlength: "Bitte mindestens {0} Buchstaben",
					maxlength: "Bitte maximal {0} Buchstaben"
				},
				Betrag: {
					requiredsum: "Bitte Betrag eingeben.",
					pattern: "Bitte geben Sie einen korrekten Betrag ein."
				},
				KostenbelegUpload: {
					allowedfiletype: "Falsches Dateiformat, folgende Formate sind erlaubt jpg, tif, pdf, png, heic und webp",
					maxfilesize: "Die Dateigröße darf 6 MB nicht überschreiten.",
					maxfilesizesummary: "Es können im Schadenmeldeprozess insgesamt nicht mehr als 150 MB hochgeladen werden.",
					maxfilecount: "Es können im Schadenmeldeprozess insgesamt nicht mehr als 25 Dateien hochgeladen werden.",
					onlySelectedFiles: "Die ausgewählte Datei hochladen oder löschen.",
					emptyActiveCostType: "Die Kostenart enthält keine Daten, bitte Kostenart abwählen oder Daten angeben.",
					customflagvalidation: "Falsches Dateiformat, konnte nicht in PDF umgewandetlt werden."
				},
				UploadRequried: {
					requiredUploadedFile: "Bitte eine Angabe machen.",
				},
				Upload: {
					allowedfiletype: "Falsches Dateiformat, folgende Formate sind erlaubt jpg, tif, pdf, png, heic und webp",
					maxfilesize: "Die Dateigröße darf 6 MB nicht überschreiten.",
					maxfilesizesummary: "Es können im Schadenmeldeprozess insgesamt nicht mehr als 150 MB hochgeladen werden.",
					maxfilecount: "Es können im Schadenmeldeprozess insgesamt nicht mehr als 25 Dateien hochgeladen werden.",
					onlySelectedFiles: "Die ausgewählte Datei hochladen oder löschen.",
					customflagvalidation: "Falsches Dateiformat, konnte nicht in PDF umgewandetlt werden."
				},
				Vorname: {
					inputcross: "Bitte geben Sie einen Vornamen und einen Nachnamen an.",
					required: "Bitte geben Sie Ihren Vornamen ein!",
					minlength: "Bitte mindestens {0} Buchstaben",
					maxlength: "Bitte maximal {0} Buchstaben",
					pattern: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!"
				},
				Nachname: {
					inputcross: "Bitte geben Sie einen Vornamen und einen Nachnamen an.",
					required: "Bitte geben Sie Ihren Nachnamen ein!",
					minlength: "Bitte mindestens {0} Buchstaben",
					maxlength: "Bitte maximal {0} Buchstaben",
					pattern: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!"
				},
				Mitgliedsnummer: {
					maxlength: "Bitte geben Sie Ihre 9-stellig Mitgliedsnummer ein.",
					number: "Bitte geben Sie Ihre 9-stellig Mitgliedsnummer ein.",
					required: "Bitte geben Sie eine Mitgliedsnummer ein."
				},
				StrasseHausnummer: {
					required: "Sie haben keine Strasse und Hausnummer eingegeben. Bitte korrigieren Sie ihre Eingabe!",
					minlength: "Bitte mindestens {0} Buchstaben",
					maxlength: "Bitte maximal {0} Buchstaben",
					streetandnumber: "Bitte korrigieren Sie Ihre Eingabe! Erlaubt sind folgende Sonderzeichen: .,-/’",
					customflagvalidation: "Bitte korrigieren Sie ihre Eingabe!"
				},
				Postleitzahl: {
					inputcross: "Sie haben keinen Ort eingegeben. Bitte korrigieren Sie ihre Eingabe!",
					required: "Sie haben keine Postleitzahl eingegeben. Bitte korrigieren Sie ihre Eingabe!",
					minlength: "Bitte mindestens {0} Zahlen",
					maxlength: "Bitte maximal {0} Ziffern / Buchstaben.",
					pattern: "Bitte geben Sie eine PLZ ein.",
					number: "Bitte nur Zahlen eingeben.",
					customflagvalidation: "Bitte korrigieren Sie ihre Eingabe!"
				},
				Ort: {
					inputcross: "Sie haben keine Postleitzahl eingegeben. Bitte korrigieren Sie ihre Eingabe!",
					required: "Sie haben keinen Ort eingegeben. Bitte korrigieren Sie ihre Eingabe!",
					minlength: "Bitte mehr als {0} Buchstaben.",
					maxlength: "Bitte maximal {0} Buchstaben.",
					pattern: "Bitte geben Sie einen Ort ein."
				},
				Email: {
					email: "Die E-Mail-Adresse ist nicht gültig!",
					required: "Bitte geben Sie eine E-Mail Adresse an.",
					customflagvalidation: "Bitte prüfen Sie Ihre Eingabe!"
				},
				TelefonVorwahl: {
					phonecross: "Bitte Vorwahl und Rufnummer angeben.",
					maxlength: "Bitte maximal {0} Zahlen.",
					customflagvalidation: "Bitte prüfen Sie Ihre Eingabe!",
					pattern: "Bitte geben Sie eine valide Vorwahl ein."
				},
				TelefonNummer: {
					phonecross: "Bitte Vorwahl und Rufnummer angeben.",
					maxlength: "Bitte maximal {0} Zahlen.",
					customflagvalidation: "Bitte prüfen Sie Ihre Eingabe!",
					pattern: "Bitte geben Sie eine valide Telefonnummer ein."
				},
				Kontoinhaber: {
					required: "Sie haben keinen Kontoinhaber eingegeben. Bitte korrigieren Sie ihre Eingabe!",
					minlength: "Bitte mehr als {0} Buchstaben.",
					maxlength: "Bitte maximal {0} Buchstaben."
				},
				Iban: {
					maxlength: "Bitte maximal {0} Ziffern / Buchstaben.",
					required: "Bitte machen Sie Angaben zu Ihrer Iban Verbindung!",
					customflagvalidation: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!"
				},
				Bic: {
					required: "Bitte machen Sie Angaben zu Ihrer BIC!",
					minlength: "Bitte mehr als {0} Ziffern / Buchstaben.",
					maxlength: "Bitte maximal {0} Ziffern / Buchstaben.",
					pattern: "Bitte nur Zahlen und Buchstanden eingeben.",
					customflagvalidation: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!"
				},
				WeitereVersicherungsgesellschaft: {
					required: "Bitte machen Sie Angaben zu Ihrer Versicherungsgesellschaft!",
					minlength: "Bitte mindestens {0} Zeichen eingeben.",
					maxlength: "Bitte maximal {0} Zeichen eingeben."
				},
				VersicherungReiseschtuz: {
					required: "Sie haben keine Auswahl getroffen. Bitte korrigieren Sie ihre Eingabe!"
				},
				VersicherungReiseschutzKreditkartengesellschaft: {
					minlength: "Bitte mindestens {0} Zeichen eingeben.",
					maxlength: "Bitte maximal {0} Zeichen eingeben."
				},
				VersicherungReiseschutzKreditkartennummer: {
					number: "Es sind nur Zahlen erlaubt.",
					minlength: "Bitte mindestens {0} Zahlen eingeben.",
					maxlength: "Bitte maximal {0} Zahlen eingeben."
				},
				VersicherungReiseschutzBankname: {
					minlength: "Bitte mindestens {0} Zeichen eingeben.",
					maxlength: "Bitte maximal {0} Zeichen eingeben."
				},
				VersicherungUnfallschutz: {
					required: "Sie haben keine Auswahl getroffen. Bitte korrigieren Sie ihre Eingabe!"
				},
				WeitereVersicherungsnummer: {
					minlength: "Bitte mindestens {0} Zeichen eingeben.",
					maxlength: "Bitte maximal {0} Zeichen eingeben."
				},
				WeitereVersicherungsgesellschaftAnschrift: {
					required: "Bitte geben Sie eine Anschrift an.",
					minlength: "Bitte mindestens {0} Zeichen eingeben.",
					maxlength: "Bitte maximal {0} Zeichen eingeben."
				},
				Datenschutz: {
					required: "Bitte bestätigen Sie... Datenschutz ..."
				},
				Obliegenheiten: {
					required: "Bitte bestätigen Sie ... Obliegenheiten ..."
				},
				Datenspeicherung: {
					required: "Bitte bestätigen Sie... Datenspeicherung ..."
				}
			},
			backend: {}
		}
	}
};
